export default function (props) {
  const { children } = props;
  return (
    <div className="edu_slide" style={{ backgroundColor: "transparent" }}>
      <div className="container">{children}</div>
    </div>
  );
}
